export const REGISTERING_COMPANY = 'REGISTERING_COMPANY';
export const REGISTERING_COMPANY_COMPLETED = 'REGISTERING_COMPANY_COMPLETED';
